export default __webpack_public_path__ + "static/media/zoologyIcon.61f30c42.svg";